import {
  Box,
  Button,
  Card,
  Grid,
  Table,
  TableBody,
  TableContainer,
} from "@mui/material";
import Container from "@mui/material/Container";
import moment from "moment";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { API_URLS, ResDataType } from "src/api/apiUrls";
import useApiServices from "src/api/useApiServices";
import AppLoadingAndErrorWrapper from "src/components/common/AppLoadingAndErrorWrapper";
import CustomBreadcrumbs from "src/components/custom-breadcrumbs/custom-breadcrumbs";
import Header from "src/components/Header";
import FormProvider from "src/components/hook-form/form-provider";
import Scrollbar from "src/components/scrollbar";
import { useSettingsContext } from "src/components/settings";
import StatisticCard from "src/components/StatisticCard";
import {
  TableHeadCustom,
  TablePaginationCustom,
  TableSkeleton,
  useTable,
} from "src/components/table";
import { useBoolean } from "src/hooks/use-boolean";
import { paths } from "src/routes/paths";
import ApplicationTableRow from "src/sections/careers/applications/ApplicationsTableRow";
import AddVacancy from "src/sections/careers/vacancies/AddVacancy";
import VacanciesTableRow from "src/sections/careers/vacancies/VacanciesTableRow";
import VacanciesTableToolbar from "src/sections/careers/vacancies/VacanciesTableToolbar";

const TABLE_HEAD = [
  { id: "1", label: "Applicant Name" },
  { id: "2", label: "Applied Vacancy" },
  { id: "3", label: "Email" },
  { id: "4", label: "Application date" },
  { id: "5", label: "Actions" },
];

export default function ApplicationsPage () {
  const dialog = useBoolean();
  const settings = useSettingsContext();
  const table = useTable({ defaultRowsPerPage: 10 });
  const { useGetListApi, useDeleteApi } = useApiServices();
  const methods = useForm({
    defaultValues: {
      translations: {
        some: {
          title: "",
        },
      },
    },
  });
  const [search, setSearch] = useState({
    title: "",
  });

  const { data, isLoading, error, refetch, isRefetching } = useGetListApi<
    ResDataType["applications"]
  >({
    url: API_URLS.APPLICATIONS,
    parameters: {
      page: table.page,
      pageSize: table.rowsPerPage,
      "translations.some.title": search.title,
    },
  });

  const { mutate, isLoading: isDeleteLoading } = useDeleteApi({
    url: API_URLS.VACANCIES,
    urlAfterSuccess: window.location.href,
    onSuccess: () => refetch(),
  });

  return (
    <>
      <Helmet>
        <title>Applicant tracking</title>
      </Helmet>
      <Container maxWidth={settings.themeStretch ? false : "xl"}>
        <CustomBreadcrumbs
          links={[
            {
              name: "Home",
              href: paths.dashboard.root,
            },
            {
              name: "Careers",
              href: paths.dashboard.careers,
            },
            {
              name: "Applicant tracking",
            },
          ]}
        />
        <AppLoadingAndErrorWrapper
          isLoading={isLoading || isDeleteLoading || isRefetching}
          errorMessage={error}
        >
          <Header header={`Today, ${moment().format("YYYY-MM-DD")}`} />
          <Grid container spacing={4} my={1}>
            <Grid item xs={12}>
              <FormProvider methods={methods}>
                <Card>
                  {/* <VacanciesTableToolbar
                    values={methods.watch()}
                    setSearch={setSearch}
                    reset={methods.reset}
                    data={data!}
                  /> */}
                  <TableContainer>
                    <Scrollbar>
                      <Table>
                        <TableHeadCustom headLabel={TABLE_HEAD} />
                        <TableBody>
                          {isLoading ? (
                            [...Array(table.rowsPerPage)].map((i, index) => (
                              <TableSkeleton key={index} sx={{ height: 80 }} />
                            ))
                          ) : (
                            <>
                              {data!?.items?.map(row => (
                                <ApplicationTableRow
                                  key={row.id}
                                  row={row}
                                />
                              ))}
                            </>
                          )}
                        </TableBody>
                      </Table>
                    </Scrollbar>
                  </TableContainer>
                  {data && (
                    <TablePaginationCustom
                      count={data?.totalItems}
                      page={data.currentPage ? +data.currentPage - 1 : 1}
                      rowsPerPage={table.rowsPerPage}
                      onPageChange={table?.onChangePage}
                      onRowsPerPageChange={table?.onChangeRowsPerPage}
                    />
                  )}
                </Card>
              </FormProvider>
            </Grid>
          </Grid>
        </AppLoadingAndErrorWrapper>
      </Container>
    </>
  );
}
